module.exports = __webpack_public_path__ + "img/66.aaf9dc1c.jpeg";